import { Box } from '@mui/material';
import '/node_modules/currency-flags/dist/currency-flags.min.css';
import '/node_modules/flag-icons/css/flag-icons.min.css';
interface IFlagProps {
	title: string;
	styleObj?: any;
}

export const Flag = ({ title, styleObj }: IFlagProps) => {
	return (
		<Box
			sx={{
				width: '30px!important',
				height: '30px',
				borderRadius: '50%',
				backgroundSize: 'cover!important',
			}}
			className={`fi fi-${title}`}
		></Box>
	);
};
